import axios from "axios";

const baseUrl = `${import.meta.env.VITE_APP_MAIN_API}${import.meta.env.VITE_APP_MAIN_JSON}${import.meta.env.VITE_APP_MAIN_EXTENDED_FIELD}`;


export const getComponent = async (id: number) => {
  return axios
    .get(`${baseUrl}/components/${id}`)
    .then((res) => res.data.acf);
};

export const getOpeningsHours = async () => {
  return axios
    .get(`${baseUrl}/closinghours/`)
    .then((res) => res.data);
};

export const getAllComponents = async () => {
  return axios
    .get(`${baseUrl}/components?per_page=100`)
    .then((res) => res.data);
};

export const getAllBanners = async () => {
  return axios.get(`${baseUrl}/banners?per_page=100`).then((res) => res.data);
};

export const getDish = async (id: number) => {
  return axios
    .get(`${baseUrl}/dishes/${id}`)
    .then((res) => res.data.acf);
};

export const getAllMenus = async () => {
  return axios.get(`${baseUrl}/menus?per_page=100`).then((res) => res.data);
};

export const getAllGalleryImages = async () => {
  return axios.get(`${baseUrl}/gallerij?per_page=100`).then((res) => res.data);
};

export const getAllDishes = async () => {
  return axios.get(`${baseUrl}/dishes?per_page=100`).then((res) => res.data);
};

export const getAllNotifications = async () => {
  return axios
    .get(`${baseUrl}/my_notifications?per_page=100`)
    .then((res) => res.data);
};

export const getAsyncComponents = async () => {
  const [hero, about, spotlight, menus, gallery, contact, privacyPolicy, cookies, openingsHours, notifications] =
    await Promise.all([
      getComponent(1099),
      getComponent(40),
      getComponent(41),
      getComponent(42),
      getComponent(43),
      getComponent(45),
      getComponent(493),
      getComponent(494),
      getOpeningsHours(),
      getAllNotifications(),
    ]);

  return { openingsHours, hero, spotlight, menus, gallery, about, contact, privacyPolicy, cookies, notifications };
};

export const getAllAlerts = async () => {
  return axios.get(`${baseUrl}/alert?per_page=100`);
};
